// LiveLoveSpain CRM - Standalone Frontend Entry Point
import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n'; // Initialize i18n before App
import App from './App';
import './index.css';

// Suppress ResizeObserver errors - these are harmless and common with libraries like ReactFlow
const originalError = console.error;
console.error = (...args) => {
  const errorMessage = args[0];
  if (
    (typeof errorMessage === 'string' && errorMessage.includes('ResizeObserver loop completed with undelivered notifications')) ||
    (errorMessage?.message && typeof errorMessage.message === 'string' && errorMessage.message.includes('ResizeObserver loop completed with undelivered notifications')) ||
    (args.some(arg => typeof arg === 'string' && arg.includes('ResizeObserver loop completed with undelivered notifications')))
  ) {
    // Suppress ResizeObserver errors - they're harmless
    return;
  }
  originalError.apply(console, args);
};

// Also suppress in window error handler
const originalErrorHandler = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  if (
    (typeof message === 'string' && message.includes('ResizeObserver loop completed with undelivered notifications')) ||
    (error?.message && error.message.includes('ResizeObserver loop completed with undelivered notifications'))
  ) {
    return true; // Suppress the error
  }
  if (originalErrorHandler) {
    return originalErrorHandler(message, source, lineno, colno, error);
  }
  return false;
};

// Also suppress in unhandled rejection handler
window.addEventListener('unhandledrejection', (event) => {
  if (
    event.reason &&
    typeof event.reason === 'string' &&
    event.reason.includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);